const YVY_Logo = ( size ) => (
  <div class="YTY-spinner">
    <svg width={ size } height={ size } viewBox={ "0 0 " + size + " " + size } xmlns="http://www.w3.org/2000/svg" stroke="#fff">
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(2 1)" stroke="#FFF" stroke-width="1.5">
              <circle cx="42.601" cy="11.462" r="5" fill-opacity="1" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="1;0;0;0;0;0;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="49.063" cy="27.063" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;1;0;0;0;0;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="42.601" cy="42.663" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;1;0;0;0;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="27" cy="49.125" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;0;1;0;0;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="11.399" cy="42.663" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;0;0;1;0;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="4.938" cy="27.063" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;0;0;0;1;0;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="11.399" cy="11.462" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;0;0;0;0;1;0" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
              <circle cx="27" cy="5" r="5" fill-opacity="0" fill="#fff">
                  <animate attributeName="fill-opacity"
                       begin="0s" dur="1.3s"
                       values="0;0;0;0;0;0;0;1" calcMode="linear"
                       repeatCount="indefinite" />
              </circle>
          </g>
      </g>
      </svg>
    </div>
);
export { YVY_Logo };

export function YVY_YoutubeLogo() {

    return <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><title/><g id="Youtube"><path d="M44.5,7h-25A12.5,12.5,0,0,0,7,19.5v25A12.5,12.5,0,0,0,19.5,57h25A12.5,12.5,0,0,0,57,44.5v-25A12.5,12.5,0,0,0,44.5,7ZM43.15,34.13l-17,9.53a2.36,2.36,0,0,1-1.18.32,2.45,2.45,0,0,1-2.45-2.45V22.47A2.45,2.45,0,0,1,24.94,20a2.36,2.36,0,0,1,1.18.32l17,9.53A2.44,2.44,0,0,1,43.15,34.13Z" fill="#ff0000"/></g></svg>
}

export function YVY_Video_In_List(list, video) {

  let found = false;
  list.map( (item) => {

    if( item.id === video.id ){
      found = true
    }
  })

  return found;
}

export function isset( arr, let_args ) {
  for (let i=1, k=arguments.length; i<k; ++i) {
    if (!arr || !arr.hasOwnProperty(arguments[i]) )
      return false
    arr = arr[arguments[i]];
  }
  return true
}

export function YVY_makeid( length=10 ) {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

export function toHHMMSS ( s ) {

  let is_h = s > 3600 ? true: false;
  let sec_num = parseInt(s, 10);
  let hours   = Math.floor(sec_num / 3600);
  let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  let seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (hours   < 10) {hours   = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}

  if( is_h ){
    return hours+':'+minutes+':'+seconds;
  } else {
    return minutes+':'+seconds;
  }
}

export function getCoords(elem) {
    let box = elem.getBoundingClientRect();

    let body = document.body;
    let docEl = document.documentElement;

    let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    let clientTop = docEl.clientTop || body.clientTop || 0;
    let clientLeft = docEl.clientLeft || body.clientLeft || 0;

    let top  = box.top +  scrollTop - clientTop;
    let left = box.left + scrollLeft - clientLeft;

    return { top: Math.round(top), left: Math.round(left) };
  }

export function mapOrder(array, order, key) {
  array.sort( function (a, b) {
    var A = a[key], B = b[key];
    
    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }
    
  });
  
  return array;
};

export function YVY_Color(){

  let original_colors = [
    {name:"WHITE", hex:"#ffffff"},
    {name:"BLACK", hex:"#000"},
    {name:"TURQUOISE", hex:"#1abc9c"},
    {name:"EMERALD",hex:"#2ecc71"},
    {name:"PETER RIVER", hex:"#3498db"},
    {name:"AMETHYST", hex:"#9b59b6"},
    {name:"WET ASPHALT", hex:"#34495e"},
    /*{name:"GREEN SEA", hex:"#16a085"},
    {name:"NEPHRITIS", hex:"#27ae60"},
    {name:"BELIZE HOLE", hex:"#2980b9"},
    {name:"WISTERIA", hex:"#8e44ad"},
    {name:"MIDNIGHT BLUE", hex:"#2c3e50"},*/
    {name:"SUN FLOWER", hex:"#f1c40f"},
    {name:"CARROT", hex:"#e67e22"},
    {name:"ALIZARIN", hex:"#e74c3c"},
    {name:"CLOUDS", hex:"#ecf0f1"},
    {name:"CONCRETE", hex:"#95a5a6"},
    {name:"ORANGE", hex:"#f39c12"},
    {name:"PUMPKIN", hex:"#d35400"},
    /*{name:"POMEGRANATE", hex:"#c0392b"},
    {name:"SILVER", hex:"#bdc3c7"},
    {name:"ASBESTOS", hex:"#7f8c8d"}*/
  ];

  let return_colors = [];
  original_colors.forEach( (color) => {

    return_colors.push({
      'name': color.name,
      'color': color.hex,
      'slug': color.name.toLowerCase()
    })

  })

  return return_colors;
}

export function YVY_hexToRgbA(hex='', opacity=100){
    let c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');

        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+', ' + ( opacity / 100 * 1 ) + ')';
    }
    throw new Error('Bad Hex');
}


// WEBPACK FOOTER //
// ./src/utils.class.js